import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import IntroPortalButton from "../Components/IntroPortalButton";

/** Provides the onClick behavior to <InputButton />
 * Controlled by the Session context, for obtaining the Customer Postal Code.
 */
const SessionContextPortalButton = SessionContextValueProvider({
  Component: IntroPortalButton,
  map: ({ customer }) => {
    return {
      zipCode: customer.zipCode
    };
  }
});

export default SessionContextPortalButton;
